import { gql } from "@apollo/client";

export const UPDATE_SETTING = gql`
  mutation ($settings: String!) {
    modifySetting(settings: $settings)
  }
`;
